class BackToTop extends HTMLElement {
  constructor() {
    super();

    if (!this.closest("body")) return;
    // This button lives at the end of the product section, so its own section
    // wrapper is the thing that has to be scrolled past
    this.anchor = this.closest(".shopify-section");
    this.button = this.querySelector("button");
  }

  connectedCallback() {
    this.scrollObserver();

    this.button.addEventListener("click", () => {
      this.scrollToTop();

      // Shift focus to first focusable element in main content
      document.querySelector("#MainContent a, #MainContent button")?.focus();
    });
  }

  scrollObserver() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // Show only once the product section has passed above the viewport. While
        // any of it, or anything preceding it, is on screen the section's bottom
        // edge is still below the top of the viewport.
        const scrolledPast =
          !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;

        scrolledPast ? this.showButton() : this.hideButton();
      });
    });

    observer.observe(this.anchor);
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  hideButton() {
    this.button.classList.add("back-to-top__button--hidden");
  }

  showButton() {
    this.button.classList.remove("back-to-top__button--hidden");
  }
}

if (!customElements.get("back-to-top")) {
  customElements.define("back-to-top", BackToTop);
}
